import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  card1: {
    marginBottom: 20,
    paddingBottom: 25,
  },
  tableContainer: {
    borderRadius: 4,
    border: 'solid 1px rgba(109, 114, 120, 0.18)',
    borderBottom: 'none',
  },
  buttonProgress: {
    position: 'absolute',
    marginTop: '-45px',
    marginLeft: '9px',
  },
  titleCell: {
    width: '50%',
    fontWeight: 'bold',
  },
  boldCell: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  subTitleData: {
    fontSize: 12,
    marginTop: 0,
  },
  amountString: {
    fontSize: 14,
    marginInlineStart: theme.spacing(2),
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    borderRadius: 8,
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    display: 'block',
    marginInlineEnd: theme.spacing(0),
    marginInlineStart: 0,
    transition: "all .1s ease-in",
    '&.active': {
      background: '#eceff1',
      borderColor: '#2B3990'
    },
  },
  radioIcon: {
    color: '#2b3990',
    fontSize: 25,
    display: 'inline-block',
    marginBottom: -8.5,
    marginInlineEnd: theme.spacing(1),
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 80px)',
    overflow: 'hidden',
    display: 'inline-flex',
  },
  radioCircle: {
    color: '#78909c',
  },
  bulkFileTitle: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    // marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    '& a': {
      fontSize: 12,
      marginInlineStart: theme.spacing(1),
      color: theme.palette.primary.main,
      background: theme.palette.primary.light,
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 20,
    },
  },
  bulkFileIcon: {
    color: theme.palette.grey[700],
    fontSize: 20,
    marginBottom: -6,
    marginInlineStart: theme.spacing(1),
    marginInlineEnd: theme.spacing(1),
  },
  optionsTitle: {
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    fontSize: 14,
  },
  alertTitle: {
    fontWeight: 'bold',
    fontSize: 14,
    paddingBottom: theme.spacing(0.5),
  },
  captcha: {
    maxHeight: 60,
    maxWidth: '100%',
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginTop: theme.spacing(3),
  },
  captchaLoading: {
    height: 85,
    width: 200,
    borderRadius: 4,
    marginInlineStart: theme.spacing(1),
    marginBottom: theme.spacing(-0.5),
  },
  BIBadge: {
    background: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontSize: 12,
    padding: '12px 4px',
    marginInlineStart: theme.spacing(1),
    display: 'inline-block',
    borderRadius: 4,
    width: '100%',
    textAlign: 'justify',
    transition: 'ease color .25s,ease background .25s',
    '&:hover': {
      background: theme.palette.primary?.light,
      color: theme.palette.primary?.dark,
    },
  },
  BIIcon: {
    fontSize: 15,
    marginBottom: theme.spacing(-0.5),
    marginInlineEnd: theme.spacing(1),
  },
}));
